export default {
    init(){
        //console.log('Nylon | Route: Home');
    },
    finalize(){}
}